import React, {useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import {useTranslation} from 'react-i18next';

import CinemaSliderVodItem from './CinemaSliderVodItem';

import './CinemaSliderVod.scss';

const CinemaSliderVod = ({cinemas}) => {
  const [visibleLinesNb, setVisibleLinesNb] = useState(3);
  const {t} = useTranslation();

  const containerRef = React.createRef();

  useEffect(() => {
    const handleScroll = e => {
      const areSomeCinemasHidden = visibleLinesNb < cinemas.length;
      if (areSomeCinemasHidden && containerRef.current.getBoundingClientRect().bottom <= window.innerHeight) {
        setVisibleLinesNb(old => old + 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [cinemas.length, containerRef, visibleLinesNb]);

  if (!cinemas) {
    return null;
  }

  return (
    <>
      {!!cinemas.length && (
        <Typography className="blanc" variant="h5" component="h3" noWrap>
          {t('VOD')}
        </Typography>
      )}
      <div ref={containerRef}>
        {cinemas.slice(0, visibleLinesNb).map(cinema => (
          <CinemaSliderVodItem cinema={cinema} key={cinema.cinema_id} />
        ))}
      </div>
    </>
  );
};

export default CinemaSliderVod;
